import type { AssetLabel } from '../../types/campaign';

// Meta Build View Preview Links pre-population (Item 5). Pure so the
// format + dedupe is unit-tested without the Build View.
//
// One line per UNIQUE asset label (first occurrence wins, original order
// preserved), formatted "{label} - " — trailing dash + space so the
// buyer pastes the preview URL right after it. Returns '' when there are
// no labels (the caller then leaves the textarea blank).
//
// This is a HINT only: the caller seeds it solely when the row has no
// Preview Links content yet, and never overrides authored content.
export function seedPreviewLinksFromLabels(
  labels: readonly AssetLabel[],
): string {
  const seen = new Set<string>();
  const lines: string[] = [];
  for (const a of labels) {
    const label = a.label?.trim();
    if (!label || seen.has(label)) continue;
    seen.add(label);
    lines.push(`${label} - `);
  }
  return lines.join('\n');
}
